export default {
    title: 'Bisher durchgeführte Maßnahmen:',
    addMeasure: 'Eintrag hinzufügen',
    maxMeasuresReached: 'Es können maximal {max} Einträge angelegt werden.',
    yearRangeInfo: 'Bitte geben Sie nur Maßnahmen der letzten 5 Jahre an ({minYear}–{maxYear}).',
    listing: {
        year: 'Jahr',
        partnerCountry: 'Partnerstaat',
        domestic: 'Inland',
        abroad: 'Ausland',
    },
}